import React from 'react'

interface RichTextOptionComponentProps {
  data: {
    title: string
    subtitle: string
    description?: string
  }
  selectOption: (data: { title: string; subtitle: string; description?: string }) => void
}

const RichTextOptionComponent: React.FC<RichTextOptionComponentProps> = (props) => (
  <div
    className='elo-react-select__option elo-react-select__option--extend-description'
    onClick={() => {
      props.selectOption(props.data)
    }}
  >
    <div className='elo-react-select__option--wrapper'>
      <div>
        <div className='elo-react-select__option--title'>{props.data.title}</div>
        <div className='elo-react-select__option--subtitle'>{props.data.subtitle}</div>
        {props.data.description && (
          <div className='elo-react-select__option--description'>{props.data.description}</div>
        )}
      </div>
    </div>
  </div>
)

export { RichTextOptionComponent }
